import { API_URL, HUB_DISPLAY_NAME, HUB_TOKEN, HUB_USER_ID } from '../config/environment';

const errorFromResponse = async (response, fallback) => {
  const text = await response.text();
  try {
    const data = JSON.parse(text);
    return data.detail || data.error || fallback;
  } catch {
    return text || fallback;
  }
};

const request = async (path, options = {}) => {
  const identityHeaders = HUB_USER_ID ? {
    'X-Hub-User-Id': HUB_USER_ID,
    ...(HUB_DISPLAY_NAME ? { 'X-Hub-Display-Name': HUB_DISPLAY_NAME } : {}),
  } : {};
  if (HUB_TOKEN) identityHeaders['X-Hub-Token'] = HUB_TOKEN;
  const response = await fetch(`${API_URL}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      ...identityHeaders,
      ...(options.headers || {}),
    },
    ...options,
  });

  if (!response.ok) {
    const error = new Error(await errorFromResponse(response, 'WordPro request failed'));
    error.status = response.status;
    throw error;
  }

  return response.json();
};

export { request };
